import React from 'react';
import { findDOMNode } from 'react-dom';
import { select } from 'd3-selection';
import kebabCase from 'lodash.kebabcase';

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Append = function (_React$Component) {
    inherits(Append, _React$Component);

    function Append() {
        classCallCheck(this, Append);
        return possibleConstructorReturn(this, (Append.__proto__ || Object.getPrototypeOf(Append)).apply(this, arguments));
    }

    createClass(Append, [{
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Append;
}(React.Component);

Append.displayName = 'Append';

var Remove = function (_React$Component) {
    inherits(Remove, _React$Component);

    function Remove() {
        classCallCheck(this, Remove);
        return possibleConstructorReturn(this, (Remove.__proto__ || Object.getPrototypeOf(Remove)).apply(this, arguments));
    }

    createClass(Remove, [{
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Remove;
}(React.Component);

Remove.displayName = 'Remove';

var SelectAll = function (_React$Component) {
    inherits(SelectAll, _React$Component);

    function SelectAll(props) {
        classCallCheck(this, SelectAll);

        var _this = possibleConstructorReturn(this, (SelectAll.__proto__ || Object.getPrototypeOf(SelectAll)).call(this, props));

        _this.el = null;
        _this.state = {
            selection: null
        };
        return _this;
    }

    createClass(SelectAll, [{
        key: 'updateSelection',
        value: function updateSelection(data, getKey) {
            var _el$selectAll;

            var selector = this.props.selector;

            var args = [data];
            if (!!getKey) args.push(getKey);
            var selection = (_el$selectAll = this.el.selectAll(selector)).data.apply(_el$selectAll, args);
            this.setState({
                selection: selection
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.el = select(findDOMNode(this));
            var _props = this.props,
                data = _props.data,
                getKey = _props.getKey;

            this.updateSelection(data, getKey);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var data = _ref.data,
                element = _ref.element,
                getKey = _ref.getKey;

            this.updateSelection(data, getKey);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                root = _props2.root;
            var selection = this.state.selection;


            return React.createElement(
                root.type,
                null,
                function () {
                    if (!!selection) {
                        // interrupt all transitions
                        selection.interrupt().selectAll('*').interrupt();

                        var childrenAsArray = React.Children.toArray(children);
                        return childrenAsArray
                        // inject selection props
                        .map(function (element) {
                            var type = element.props.type;

                            var currentSelection = null;
                            if (type === 'enter') {
                                currentSelection = selection.enter();
                            } else if (type === 'update') {
                                currentSelection = selection;
                            } else if (type === 'exit') {
                                currentSelection = selection.exit();
                            }
                            return React.cloneElement(element, _extends({}, element.props, {
                                selection: currentSelection
                            }));
                        });
                    }
                }()
            );
        }
    }]);
    return SelectAll;
}(React.Component);

var isAttrAnEvent = function isAttrAnEvent(attr) {
    return attr.length > 2 && attr.slice(0, 2) === 'on';
};

var elementToTagName = function elementToTagName(element) {
    return element.type;
};

var elementToAttrs = function elementToAttrs(element) {
    var _element$props = element.props,
        children = _element$props.children,
        className = _element$props.className,
        others = objectWithoutProperties(_element$props, ['children', 'className']);
    // We have to remove events

    var keys = !!others ? Object.keys(others).filter(function (key) {
        return !isAttrAnEvent(key);
    }) : [];
    var attrs = {};
    // class
    if (!!className) {
        attrs['class'] = className;
    }
    // other attrs
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            attrs[kebabCase(key)] = others[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return attrs;
};

var elementToEvents = function elementToEvents(element) {
    var _element$props2 = element.props,
        children = _element$props2.children,
        className = _element$props2.className,
        others = objectWithoutProperties(_element$props2, ['children', 'className']);
    // We only keep events

    var keys = !!others ? Object.keys(others).filter(isAttrAnEvent) : [];
    var events = {};
    // other attrs
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            var eventName = key.slice(2).toLowerCase();
            events[eventName] = others[key];
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return events;
};

var elementToStyles = function elementToStyles(element) {
    var style = element.props.style;

    if (!style) {
        return {};
    }
    var keys = Object.keys(style);
    var styles = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = keys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            styles[kebabCase(key)] = style[key];
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return styles;
};

var Selection = function (_React$Component) {
    inherits(Selection, _React$Component);

    function Selection() {
        classCallCheck(this, Selection);
        return possibleConstructorReturn(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).apply(this, arguments));
    }

    createClass(Selection, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                selection = _props.selection;

            var childrenAsArray = React.Children.toArray(children);

            childrenAsArray
            // chaining selection
            .reduce(function (selection, element, index) {
                if (element.type.displayName === 'Remove') {
                    return selection.remove();
                }
                var children = element.props.children;

                var child = React.Children.only(children);
                if (element.type.displayName === 'Append') {
                    var tagName = elementToTagName(child);
                    var attrs = elementToAttrs(child);
                    var styles = elementToStyles(child);
                    var events = elementToEvents(child);
                    var eventNames = Object.keys(events);
                    var newSelection = selection.append(tagName).attrs(attrs).styles(styles);
                    // no events, we return the current selection
                    if (!eventNames.length) {
                        return newSelection;
                    }
                    // with events, we have to chain selections
                    return eventNames.reduce(function (selection, eventName) {
                        return selection.on(eventName, events[eventName]);
                    }, newSelection);
                } else if (element.type.displayName === 'Transition') {
                    var duration = element.props.duration;

                    var _attrs = elementToAttrs(child);
                    var _styles = elementToStyles(child);
                    return selection.transition().duration(duration).attrs(_attrs).styles(_styles);
                }
            }, selection);
            return null;
        }
    }]);
    return Selection;
}(React.Component);

var Transition = function (_React$Component) {
    inherits(Transition, _React$Component);

    function Transition() {
        classCallCheck(this, Transition);
        return possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).apply(this, arguments));
    }

    createClass(Transition, [{
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Transition;
}(React.Component);

Transition.displayName = 'Transition';

export { Append, Remove, SelectAll, Selection, Transition };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@seracio/thirdact/dist/thirdact.es6.js
// module id = 259
// module chunks = 0